import React, { useState, useEffect } from 'react';
import {
  MotifButton,
  MotifTabNavigation as MotifTabNav,
  MotifTabControl,
} from '@ey-xd/motif-react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
  Recoil_Gcsp_Quarter_State,
  Pl_Failure_Modal_State,
  Current_User,
  Recoil_All_Accounts_Quarter_State,
  Active_Tab_Gcsp,
  System_Date_Time_State,
  Next_Button_Active_State,
  All_Month_Data_State,
  Pl_Submit_Success_Modal_State,
  Country_Name_State,
  Refresh_Pills_Status_State,
  Submission_Failure,
  Loading_Modal_State,
} from '@recoil/recoil';
import { dateFormatMonth, getPeriodForMonth } from '@util/commonUtil';
import LoadingModal from '@organisms/modals/loadingModal';

import {
  SubmitButtonContainer,
  SubHeaderContainerGcsp,
  TabStep,
  TabMonth,
  TabDates,
  TabPrevButton,
  TabNextButton,
} from '@atoms/subHeaderText/subHeader.styles';
import { PAGE, SOURCE, LOGOUT_SCREEN } from '@constants/commonConstants';
import {
  getAlertBarDetails,
  isCurrentUserExist,
  logError,
  GcspPostChangeKeys,
} from '@util/commonFunctions';
import FailureTransactionModal from '@organisms/modals/failureTransactionModal';
import SuccessTransactionModal from '@organisms/modals/SuccessTransactionModal';
import '@molecules/gcsp/styles/tableHeaderStyle.css';
import { getLogOutStatus, getOpportunitiesDue } from '@services/commonServices';
import { useNavigate } from 'react-router-dom';
import { submitGCSPopportunity } from '@services/gcspServices';
import { appInsights } from '@services/appInsightsService';
import { hasSystemTimePassed } from '../../../../util/commonUtil';

const SubHeaderGcsp = () => {
  const [quarterData, setQuarterData] = useRecoilState(Recoil_Gcsp_Quarter_State);
  const showFailureSubmitModal = useRecoilValue(Pl_Failure_Modal_State);
  const currentUser = useRecoilValue(Current_User);
  const allAccountsQuarterData = useRecoilValue(Recoil_All_Accounts_Quarter_State);
  const systemDateTime = useRecoilValue(System_Date_Time_State);
  const [tabActive, setTabActive] = useRecoilState(Active_Tab_Gcsp);
  const [nextButtonActive, setNextButtonActive] = useRecoilState(Next_Button_Active_State);
  const [monthChipInfo, setMonthChipInfo] = useState({}); // eslint-disable-line
  const setShowFailureSubmitModal = useSetRecoilState(Pl_Failure_Modal_State);
  const refreshPillStatus = useRecoilValue(Refresh_Pills_Status_State);

  const allMonthData = useRecoilValue(All_Month_Data_State);
  const countryName = useRecoilValue(Country_Name_State);
  const [, setShowSubmissionFailureModal] = useRecoilState(Submission_Failure);
  const [showLoadingModal, setShowLoadingModal] = useRecoilState(Loading_Modal_State);
  const [showSubmitConfirmationModal, setShowSubmitConfirmationModal] = useRecoilState(
    Pl_Submit_Success_Modal_State,
  );
  let alertStatusDetails;
  const navigate = useNavigate();

  useEffect(() => {
    if (currentUser !== null) {
      getOpportunitiesDue(currentUser.role, currentUser.email, systemDateTime.split('T')[0])
        .then(result => {
          setQuarterData(result);
        })
        .catch(error => {
          logError('getOpportunitiesDue', error);
        });
    }
  }, [currentUser]);

  useEffect(() => {
    if (quarterData !== null && currentUser !== null && allAccountsQuarterData !== null) {
      getMotifChip();
    }
  }, [quarterData, currentUser, allAccountsQuarterData, refreshPillStatus]);

  const month = quarterData ? quarterData.month : '';
  const SecondMonth = quarterData ? quarterData.next_month : '';
  const ThirdMonth = quarterData ? quarterData.next2next_month : '';
  const StartDate = quarterData ? dateFormatMonth(quarterData.current_month_start_date) : '';
  const EndDate = quarterData ? dateFormatMonth(quarterData.current_month_end_date) : '';
  const SecondMonthStartDate = quarterData
    ? dateFormatMonth(quarterData.next_month_start_date)
    : '';
  const SecondMonthEndDate = quarterData ? dateFormatMonth(quarterData.next_month_end_dt_date) : '';
  const ThirdMonthStartDate = quarterData
    ? dateFormatMonth(quarterData.next2next_month_start_date)
    : '';
  const ThirdMonthEndDate = quarterData
    ? dateFormatMonth(quarterData.next2next_month_end_date)
    : '';

  const TodaysDate = systemDateTime ? new Date(systemDateTime) : new Date();
  const personaStartDateCheck = quarterData ? new Date(quarterData.persona_startdate) : new Date();
  const personaCloseDateCheck = quarterData ? new Date(quarterData.persona_closedate) : new Date();
  const isReadOnly = localStorage.getItem('isReadOnly') === 'true';
  let IsSubmitDisabled = false;

  IsSubmitDisabled =
    (isReadOnly && tabActive === 2) ||
    (!(TodaysDate >= personaStartDateCheck && TodaysDate <= personaCloseDateCheck) &&
      tabActive === 2) ||
    (tabActive === 2 &&
      localStorage.getItem('isSuperUser') == 'true' &&
      localStorage.getItem('targetUserEmail') !== 'null')
      ? true // Disable
      : false; // Enable

  const getMotifChip = async () => {
    const apiPayload = {
      email: currentUser.email,
      role: currentUser.role,
      month: quarterData.month.toLowerCase(),
      year: quarterData.fiscal_year,
      accountId: currentUser.account_id,
      read_only: localStorage.getItem('isReadOnly') === 'true' ? true : false,
    };

    try {
      alertStatusDetails = await getAlertBarDetails(
        allAccountsQuarterData[apiPayload.role],
        apiPayload,
        PAGE.FORECAST,
        systemDateTime,
      );

      setMonthChipInfo(alertStatusDetails);
    } catch (error) {
      logError('getAlertBarDetails', error);
    }
  };

  const submitOpportunities = async () => {
    const ACCOUNTID = currentUser.account_id;
    const MONTH = quarterData.month;
    const YEAR = quarterData.fiscal_year;
    const QUARTER = quarterData.quarter;

    let JUDGE_DATA_REQ_BODY = []; // Judge Data
    let ROLLING_JUDGE_DATA_REQ_BODY = []; // Rolling Judge Data

    const result = [];

    // Extract data from allMonthData
    Object.keys(allMonthData).forEach((key, index) => {
      const item = allMonthData[key];
      if (item.Your_Judge) {
        result[index] = { ...item.Your_Judge[0] };
      }
    });

    const isRollingData = true;
    const SubmissionType = 'month';

    // Use fiscal month instead of current calendar month to match judge data
    // This fixes the issue when GCSP window opens on mid current month (29th-30th Sept) for October fiscal month
    JUDGE_DATA_REQ_BODY = result?.find(obj => obj.month === MONTH);

    if (Object.keys(result).length !== 0) {
      JUDGE_DATA_REQ_BODY = GcspPostChangeKeys([JUDGE_DATA_REQ_BODY], SubmissionType, false, MONTH);
      ROLLING_JUDGE_DATA_REQ_BODY = GcspPostChangeKeys(
        result,
        SubmissionType,
        isRollingData,
        MONTH,
      );
    }

    // Insert judge_comment into rolling_judge
    ROLLING_JUDGE_DATA_REQ_BODY = ROLLING_JUDGE_DATA_REQ_BODY.map((item, index) => {
      const judge_comment = allMonthData[index]?.Your_Judge?.[0]?.judge_comment || ''; // Extract judge_comment from allMonthData
      return { ...item, judge_comment }; // Add judge_comment to the rolling_judge object
    });

    const RequestBody = {
      account_id: ACCOUNTID,
      month: MONTH,
      year: YEAR,
      quarter: QUARTER,
      email: currentUser.email,
      role: currentUser.role,
      performing_segment: currentUser.account_id,
      judge: JUDGE_DATA_REQ_BODY[0],
      rolling_judge: ROLLING_JUDGE_DATA_REQ_BODY,
    };

    try {
      const postSubmitGCSPopportunity = await submitGCSPopportunity(RequestBody);
      if (postSubmitGCSPopportunity === true) {
        // If Response true
        appInsights.trackTrace({
          message: JSON.stringify({
            message: `Gcsp successfully submitted opportunitis for ${QUARTER} ${MONTH} ${YEAR}  `,
            userId: localStorage.getItem('userEmail'),
            source: SOURCE.FRONTEND,
          }),
          severityLevel: 1, // 1 represents response log
        });

        setShowLoadingModal(false); // Hide Loading Modal
        setShowSubmitConfirmationModal(true); // Showing Success Modal When Response is 200
      } else {
        setShowLoadingModal(false); // Hide Loading Modal
        setShowFailureSubmitModal(true); // Showing Error Modal
      }
    } catch (error) {
      setShowLoadingModal(false); // Hide Loading Modal
      setShowFailureSubmitModal(true); // Showing Error Modal
      appInsights.trackTrace({
        message: JSON.stringify({
          message: `Error while submitting gcsp opportunities: ${error}  `,
          userId: localStorage.getItem('userEmail'),
          source: SOURCE.FRONTEND,
        }),
        severityLevel: 3, // 3 represents failure
      });
    }
  };

  const initSubmission = async () => {
    const isUserExist = await isCurrentUserExist(countryName);
    if (isUserExist) {
      const isSystemTimePassed = hasSystemTimePassed(personaCloseDateCheck);
      if (isSystemTimePassed) {
        setShowSubmissionFailureModal(true);
      } else {
        setShowLoadingModal(true);
        // Submit API Function Call
        submitOpportunities();
      }
    } else {
      getLogOutStatus(localStorage.getItem('userEmail'))
        .then(() => {
          localStorage.clear();
          sessionStorage.clear();
          navigate('/logout', {
            state: {
              TITLE: LOGOUT_SCREEN.HEADER_TITLE,
              DESCRIPTION: LOGOUT_SCREEN.DESCRIPTION,
              BUTTON_TITLE: LOGOUT_SCREEN.BUTTON_TITLE,
            },
          });
        })
        .catch(error => {
          appInsights.trackTrace({
            message: JSON.stringify({
              message: `Error while submitting gcsp opportunities: ${error}  `,
              userId: localStorage.getItem('userEmail'),
              source: SOURCE.FRONTEND,
            }),
            severityLevel: 3, // 3 represents failure
          });
        });
    }
  };

  useEffect(() => {
    setTabActive(0);
  }, []);

  return (
    <SubHeaderContainerGcsp>
      <div style={{ display: 'flex', justifyContent: 'space-between', paddingRight: 10, gap: 15 }}>
        <MotifTabNav>
          <MotifTabControl
            disabled
            className={tabActive === 0 ? 'motif-active' : ''}
            style={tabActive === 0 ? { background: '#FFE600' } : {}}
          >
            <TabStep>STEP 1: Final Forecast</TabStep>
            <TabMonth>
              {' '}
              Fiscal {month} ({getPeriodForMonth(month)}){' '}
            </TabMonth>
            <TabDates>
              {' '}
              {StartDate}- {EndDate}
            </TabDates>
          </MotifTabControl>

          <MotifTabControl
            disabled
            className={tabActive === 1 ? 'motif-active' : ''}
            style={tabActive === 1 ? { background: '#FFE600' } : {}}
          >
            <TabStep>STEP 2: Projected Forecast</TabStep>
            <TabMonth>
              Fiscal {SecondMonth} ({getPeriodForMonth(SecondMonth)})
            </TabMonth>
            <TabDates>
              {' '}
              {SecondMonthStartDate}- {SecondMonthEndDate}
            </TabDates>
          </MotifTabControl>

          <MotifTabControl
            disabled
            className={tabActive === 2 ? 'motif-active' : ''}
            style={tabActive === 2 ? { background: '#FFE600' } : {}}
          >
            <TabStep>STEP 3: Projected Forecast</TabStep>
            <TabMonth>
              Fiscal {ThirdMonth} ({getPeriodForMonth(ThirdMonth)})
            </TabMonth>
            <TabDates>
              {' '}
              {ThirdMonthStartDate}- {ThirdMonthEndDate}
            </TabDates>
          </MotifTabControl>
        </MotifTabNav>
      </div>

      <SubmitButtonContainer>
        <LoadingModal showLoadingModal={showLoadingModal} />
        <SuccessTransactionModal showSubmitConfirmationModal={showSubmitConfirmationModal} />
        <div style={{ padding: 20, display: 'flex' }}>
          <TabPrevButton>
            <MotifButton
              onClick={() => {
                setTabActive(tabActive - 1);
              }}
              disabled={tabActive === 0}
              style={
                tabActive === 0
                  ? { background: ' #FFFFFF', color: '#2E2E38', border: '1px solid #2E2E38' }
                  : {}
              }
              className="TabPrevButton"
            >
              Previous
            </MotifButton>
          </TabPrevButton>
          <TabNextButton>
            {nextButtonActive ? (
              <MotifButton
                onClick={() => {
                  if (tabActive < 2) {
                    setNextButtonActive(false);
                    setTabActive(tabActive + 1);
                  } else {
                    initSubmission();
                  }
                }}
                disabled={IsSubmitDisabled}
                className="TabNextButton"
              >
                {tabActive === 2 ? 'Submit' : 'Next'}
              </MotifButton>
            ) : (
              <MotifButton disabled={true} className="TabNextButton">
                Next
              </MotifButton>
            )}
          </TabNextButton>
        </div>
        <FailureTransactionModal showFailureSubmitModal={showFailureSubmitModal} />
      </SubmitButtonContainer>
    </SubHeaderContainerGcsp>
  );
};

export default SubHeaderGcsp;
